import { Outlet } from "react-router-dom"


const ShowCaseWatchLayout = () => {
    return (
        <Outlet />
    )
}

export default ShowCaseWatchLayout